<template>
    <v-card class="trainer-card" @click="$emit('click')">
        <div class="trainer-card__name">{{ trainer.fullName || trainer.name }}</div>

        <div class="trainer-card__portrait-row">
            <div class="trainer-card__badge-col trainer-card__badge-col--left" v-if="badgesLeft.length">
                <v-img
                    v-for="badge in badgesLeft"
                    :key="badge.id"
                    class="trainer-card__badge"
                    :src="require(`@/assets/pic/badge/${badge.id}.png`)"
                    contain
                />
            </div>

            <div class="trainer-card__image-wrap">
                <v-img
                    v-if="trainer.img"
                    class="trainer-card__image"
                    :src="require(`@/assets/pic/trainer/${trainer.img}`)"
                    contain
                />
                <div class="trainer-card__level-bubble">
                    <div class="trainer-card__level-star-wrap">
                        <v-icon size="36" color="#ffebbc">mdi-star</v-icon>
                    </div>
                    <span>{{ trainer.experience.level }}</span>
                </div>
            </div>

            <div class="trainer-card__badge-col trainer-card__badge-col--right" v-if="badgesRight.length">
                <v-img
                    v-for="badge in badgesRight"
                    :key="badge.id"
                    class="trainer-card__badge"
                    :src="require(`@/assets/pic/badge/${badge.id}.png`)"
                    contain
                />
            </div>
        </div>

        <div class="trainer-card__status" v-if="positionLabel">
            <div class="trainer-card__status-now">
                <span v-if="currentCityName">{{ currentCityName }} – </span>{{ positionLabel }}
            </div>
            <div class="trainer-card__status-next">→ {{ nextCityName || $t('trainer.trainerCard.lostCity') }}</div>
        </div>
    </v-card>
</template>

<script>
    export default {
        name: 'TrainerCard',
        props: {
            trainer: {type: Object, required: true},
        },
        computed: {
            badgesLeft() {
                const badges = this.trainer.badges || [];
                return badges.slice(0, Math.ceil(badges.length / 2));
            },
            badgesRight() {
                const badges = this.trainer.badges || [];
                return badges.slice(Math.ceil(badges.length / 2));
            },
            // $t() uvnitr - musi byt computed, ne modulovy const, viz .superpowers/sdd/i18n-conventions.md bod 8
            positionLabels() {
                const p = 'trainer.trainerCard.positions.';
                return {
                    CITY: this.$t(p + 'city'),
                    DUNGEON: this.$t(p + 'dungeon'),
                    DUNGEON_WIN: this.$t(p + 'dungeonWin'),
                    DUNGEON_CHALLENGE: this.$t(p + 'dungeonChallenge'),
                    DUNGEON_CHALLENGE_WIN: this.$t(p + 'dungeonChallengeWin'),
                    STADION: this.$t(p + 'stadion'),
                    LEAGUE_REGISTER: this.$t(p + 'leagueRegister'),
                    LEAGUE_OAK: this.$t(p + 'leagueOak'),
                    LEAGUE_FIGHT: this.$t(p + 'leagueFight'),
                    MEWTWO_FIGHT: this.$t(p + 'mewtwoFight'),
                    MEWTWO_FIGHT_WIN: this.$t(p + 'mewtwoFightWin'),
                    LEAGUE_WIN: this.$t(p + 'leagueWin'),
                    LEAGUE_LOSE: this.$t(p + 'leagueLose'),
                    WILD: this.$t(p + 'wild'),
                    WILD_OBSTACLE: this.$t(p + 'wildObstacle'),
                    ENCOUNTER: this.$t(p + 'encounter'),
                    FIGHT: this.$t(p + 'fight'),
                    FIGHT_TRAINER: this.$t(p + 'fightTrainer'),
                    FIGHT_TEAM_ROCKET: this.$t(p + 'fightTeamRocket'),
                    FIGHT_STADION_TRAINER_WIN: this.$t(p + 'fightStadionTrainerWin'),
                    FIGHT_WILD_TRAINER_WIN: this.$t(p + 'fightWildTrainerWin'),
                    OAK: this.$t(p + 'oak'),
                    OFFICER_JENNY: this.$t(p + 'officerJenny'),
                    START: this.$t(p + 'start'),
                };
            },
            positionLabel() {
                const type = this.trainer.position && this.trainer.position.type;
                if (!type) return null;
                return this.positionLabels[type] || type;
            },
            nextCityName() {
                const nextCity = this.trainer.position && this.trainer.position.nextCity;
                return nextCity ? this.$t('common.cityNames.' + nextCity.name) : null;
            },
            currentCityName() {
                const city = this.trainer.position && this.trainer.position.city;
                return city ? this.$t('common.cityNames.' + city.name) : null;
            },
        },
    }
</script>

<style scoped>
    .trainer-card {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        padding: 8px 6px 6px;
        container-type: inline-size;
        transition: transform .12s ease, box-shadow .12s ease;
    }

    .trainer-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, .35);
    }

    .trainer-card__name {
        width: 100%;
        text-align: center;
        font-weight: 700;
        font-size: clamp(13px, 6px + 4.5cqi, 19px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .trainer-card__portrait-row {
        width: 100%;
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 6px;
    }

    .trainer-card__badge-col {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        flex: 0 0 auto;
        position: relative;
        top: -10px;
        z-index: 2;
    }

    .trainer-card__badge-col--left {
        margin-right: -13.5cqi;
    }

    .trainer-card__badge-col--right {
        margin-left: -13.5cqi;
    }

    .trainer-card__badge {
        width: clamp(24px, 17cqi, 33px);
        height: clamp(24px, 17cqi, 33px);
        flex: 0 0 auto;
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, .5));
    }

    .trainer-card__image-wrap {
        position: relative;
        flex: 0 0 auto;
        width: clamp(130px, 88cqi, 203px);
        height: clamp(156px, 109cqi, 239px);
        display: flex;
        z-index: 1;
    }

    .trainer-card__image {
        flex: 1 1 auto;
    }

    .trainer-card__level-bubble {
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 2;
        width: clamp(25px, 21cqi, 37px);
        height: clamp(25px, 21cqi, 37px);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: radial-gradient(circle at 30% 30%, #ffffff, #494949);
        box-shadow: 2px 3px 8px rgba(0, 0, 0, .5);
    }

    .trainer-card__level-bubble span {
        position: relative;
        z-index: 1;
        font-weight: 900;
        font-size: clamp(12px, 9.6cqi, 17px);
        color: #000;
    }

    .trainer-card__level-star-wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, calc(-50% - 2px));
        z-index: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .trainer-card__status {
        width: 100%;
        text-align: center;
        margin-top: 6px;
        line-height: 1.25;
    }

    .trainer-card__status-now {
        font-weight: 700;
        font-size: clamp(11px, 4px + 3cqi, 14px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .trainer-card__status-next {
        font-size: clamp(10px, 3px + 2.6cqi, 12px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .theme--light .trainer-card__status-next {
        color: rgba(0, 0, 0, .6);
    }
    .theme--dark .trainer-card__status-next {
        color: rgba(255, 255, 255, .7);
    }
</style>
